import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { guardString } from "@msuite/utils/strings";
import { ArticleImageTile } from "@/components/stock/article-image-tile";
import { useArticle } from "@/hooks/use-article";
import type { ArticlePanelBaseProps } from "../shared";

export function ArticleImage({ articleId }: ArticlePanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { article } = useArticle(articleId);

	/** Render */
	return (
		<ContentCard
			title={t("images.image")}
			icon={icon("Image")}
		>
			<ArticleImageTile
				articleId={articleId}
				alt={guardString(article?.name)}
			/>
		</ContentCard>
	);
}
